import { render } from "./ProgressDiagram.vue?vue&type=template&id=135fd7f6"
import script from "./ProgressDiagram.vue?vue&type=script&lang=js"
export * from "./ProgressDiagram.vue?vue&type=script&lang=js"

import "./ProgressDiagram.vue?vue&type=style&index=0&id=135fd7f6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__